import { render, staticRenderFns } from "./ModalMostrarProgramas.vue?vue&type=template&id=6dcdea7a"
import script from "./ModalMostrarProgramas.vue?vue&type=script&lang=js"
export * from "./ModalMostrarProgramas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports